import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useIsMobile } from "@/lib/useMobile";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import Home from "@/pages/Home";
import Setup from "@/pages/Setup";
import Live from "@/pages/Live";
import Report from "@/pages/Report";
import Users from "@/pages/Users";

const guard = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
  const isMobile = useIsMobile();
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/" element={guard(<Home />)} />
            <Route path="/novo" element={guard(<Setup />)} />
            <Route path="/utilizadores" element={guard(<Users />)} />
            <Route path="/jogo/:id/configurar" element={guard(<Setup />)} />
            <Route path="/jogo/:id" element={guard(<Live />)} />
            <Route path="/jogo/:id/relatorio" element={guard(<Report />)} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position={isMobile ? "bottom-center" : "top-center"} richColors />
    </div>
  );
}

export default App;
